<template>
  <b-card class="cardStyle" no-body>
    <section class="cardBody">
      <b-row class="justify-content-between text-center">
        <b-col class="d-flex align-items-center my-3" cols="12" lg="12" md="12" sm="12" xl="auto">
          <div class="detailsText" style="display: flex; align-items: center">
            <b-icon icon="house-fill" scale="1.0" style="margin-right: 10px"></b-icon>
            Site Details
          </div>
        </b-col>

        <b-col class="my-3 px-0" cols="6" lg="1" md="2" sm="6" xl="1">
          <label class="labelStyle">ID</label>
          <div class="siteNumberStyle">
            {{ information['siteInfo']['siteNumber'] }}
          </div>
        </b-col>

        <b-col class="my-3 px-0" cols="6" lg="2" md="2" sm="6" xl="2">
          <label class="labelStyle">Status</label>
          <div id="studyStatus">
            <status :status="information['siteInfo']['simplifySiteStatus']" />
          </div>
        </b-col>

        <b-col class="my-3" cols="6" lg="4" md="4" sm="6" xl="3">
          <label class="labelStyle" for="immediateMilestone">PI Name</label>
          <div id="PIName" class="boldInfoStyle">
            {{ information['siteInfo']['investigatorName'] }}
          </div>
        </b-col>

        <b-col class="my-3" cols="6" lg="4" md="4" sm="6" xl="3">
          <label class="labelStyle" for="nextTargetMilestone"
            >First Subject First Visit (FSFV)</label
          >
          <div id="nextTargetMilestone" class="boldInfoStyle" v-if="fsfv">{{ fsfv }}</div>
          <div id="nextTargetMilestone" class="boldInfoStyle" v-else>No Dates Available</div>
        </b-col>

        <b-col class="my-3" cols="1">
          &nbsp;
        </b-col>
      </b-row>
    </section>
  </b-card>
</template>

<script>
  import moment from 'moment';
  import arrowUpCircle from '../../../../images/arrowUpCircle.png';
  import arrowDownCircle from '../../../../images/arrowDownCircle.png';
  import PreStepper from './PreStepper';
  import Status from '../../common/Status';

  export default {
    name: 'SiteDetails',
    components: {
      PreStepper,
      Status,
    },
    props: {
      milestones: {
        type: Array,
        default: [],
      },
      information: {
        type: Object,
        default: {},
      },
    },
    data() {
      return {
        toggleDetails: false,
        arrowUpCircle: arrowUpCircle,
        arrowDownCircle: arrowDownCircle,
        notAvailableText: 'Not Available',
      };
    },
    computed: {
      roles() {
        return this.information?.associations?.[0]?.role;
      },
      fsfv() {
        let fsfv = this.milestones.find(el =>
          ['Site FSFV', 'Site FSFV Date'].includes(el['milestoneName']),
        );
        if (fsfv) {
          if ('actualDate' in fsfv && fsfv['actualDate']) {
            return 'Actual Date: ' + moment(fsfv['actualDate']).format('DD MMM YYYY');
          }
          if ('plannedDate' in fsfv && fsfv['plannedDate']) {
            return 'Planned Date: ' + moment(fsfv['plannedDate']).format('DD MMM YYYY');
          }
        }
      },
    },
  };
</script>

<style scoped>
  .detailsText {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: #0060aa;
  }
  .siteNumberStyle {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #0064c1;
  }
  .labelStyle {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }
  .boldInfoStyle {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.25px;
    color: #0064c1;
  }
  .cardBody {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 0rem 1.5rem;
  }
</style>
